import { Controller } from 'stimulus';

export default class extends Controller {
  #onUpdate = null;
  static values = { collectionName: String };

  connect() {
    this.#onUpdate = this.#updateForm.bind(this);
    this.element.addEventListener('batch-action-bar:update', this.#onUpdate);
  }

  disconnect() {
    this.element.removeEventListener('batch-action-bar:update', this.#onUpdate);
  }

  #updateForm(event) {
    this.#clearGeneratedInputs();

    event.detail.selected.forEach((element, index) => {
      this.#addInputFor('item_type', element.resource_type, index);
      this.#addInputFor('item_id', element.resource_id, index);
    });
  }

  #addInputFor(attribute, value, index) {
    const input = document.createElement('input');
    input.classList.add(this.#inputClass);
    input.type = 'hidden';
    input.name = `${this.collectionNameValue}[${index}][${attribute}]`;
    input.value = value;

    this.element.appendChild(input);
  }

  #clearGeneratedInputs() {
    const inputs = this.element.querySelectorAll(`.${this.#inputClass}`);
    inputs.forEach((input) => input.remove());
  }

  get #inputClass() {
    return 'batch-action-fields';
  }
}
